import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import { AuthenticationService } from './authentication.service';
import { EnvironmentService } from './index';
import {CustomerTyre} from '../_models/customerTyre';
import {Tyre} from '../_models/tyre';
import {CustomersService} from './customers.service';


@Injectable()
export class CustomerTyresService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private customersService: CustomersService,
    private environmentService: EnvironmentService) {
  }


  getDealer(id: string): Observable<CustomerTyre[]>{
    let customerTyre$ = this.http
      .get(`${this.baseUrl}/customer-tyres?dealer_id=${id}`, this.makeHeaders())
      .map(mapAny)
      .catch(handleError);
    return customerTyre$;
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json');

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function mapAny(response: Response): any[] {
  return response.json().map(toAny);
}

function toAny(r: any): any {
  let object: any;
  object = r;
  return object;
}

function mapCustomerTyres(response: Response): CustomerTyre[]{
  // uncomment to simulate error:
  // throw new Error('ups! Force choke!');
  return response.json().map(toCustomerTyre);
}

function mapCustomerTyre(response:Response): CustomerTyre{
  // toPerson looks just like in the previous example
  return toCustomerTyre(response.json());
}

function toCustomerTyre(r:any): CustomerTyre {
  let customerTyre = <CustomerTyre>({
    _id: r._id,
  });
  // console.log('Parsed car:', car);
  return customerTyre;
}

// this could also be a private method of the component class
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/customertyres.service.ts